var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{staticClass:"py-3"},[_c('b-row',[_c('b-col',[(!_vm.item)?_c('page-loading'):_vm._e(),(_vm.item)?_c('page-title',{attrs:{"title":_vm.pageTitle}}):_vm._e(),_c('hr'),(_vm.item)?_c('div',{staticClass:"mt-3"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.item.contentHtml)}})]):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }